import { type MarkerType, type PositionHistoryClickItem } from '#/types/messages/positions-history-payload.types';

import { type ChartSize, DeviceType, type IframePayload, type LineDragEndPayload, ParentApp } from './device.types';

export class WebTradingService extends ParentApp {
  serviceName = 'WebTradingService';

  protected get control() {
    return window.parent.postMessage.bind(window.parent);
  }

  isDevice(device: DeviceType): boolean {
    return device === DeviceType.Iframe;
  }

  onAppReadyListenMessages(): void {
    const payload: IframePayload = {
      event: 'onTradingViewChartLoaded',
    };

    this.control(payload, '*');
  }

  setChartSize(size: ChartSize) {
    const payload: IframePayload = {
      event: 'setChartSize',
      payload: {
        size,
      },
    };

    this.control(payload, '*');

    return size;
  }

  openUiElementsDisplayConfiguration(): void {
    const payload: IframePayload = {
      event: 'openTradeConfiguration',
    };

    this.control(payload, '*');
  }

  onHmrInfoButtonPressed(): void {
    const payload: IframePayload = {
      event: 'hmrIconPressed',
    };

    this.control(payload, '*');
  }

  onPositionsHistoryMarkerPressed(positions: PositionHistoryClickItem[], markerType: MarkerType): void {
    const payload: IframePayload = {
      event: 'positionsHistoryMarkerPressed',
      payload: positions,
      markerType,
    };

    this.control(payload, '*');
  }

  onSymbolChanged(symbol: string): void {
    const payload: IframePayload = {
      event: 'symbolChanged',
      payload: { symbol },
    };

    this.control(payload, '*');
  }

  requestPositionsHistory(range: { from: number; to: number }): void {
    const payload: IframePayload = {
      event: 'requestPositionsHistory',
      payload: range,
    };

    this.control(payload, '*');
  }

  onLineDragEnd(payload: LineDragEndPayload): void {
    const iframePayload: IframePayload = {
      event: 'onLineDragEnd',
      payload,
    };

    this.control(iframePayload, '*');
  }
}
